var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePlaceHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_14315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.288 -22.3119H-22.312V222.288H222.288V-22.3119Z",
    fill: "#E4E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9924 131.25C59.7203 131.25 26.8388 167.293 24.9995 212.5H175C173.155 167.289 140.262 131.25 99.9924 131.25Z",
    fill: "#AEB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5 81.2495C137.5 101.96 120.71 118.75 99.9995 118.75C79.2892 118.75 62.4995 101.96 62.4995 81.2495C62.4995 60.5388 79.2892 43.7495 99.9995 43.7495C120.713 43.7495 137.5 60.5415 137.5 81.2495Z",
    fill: "#AEB4B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_14315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceHolder);
export default __webpack_public_path__ + "static/media/profilePlaceHolder.8ce79c60.svg";
export { ForwardRef as ReactComponent };